import $ from 'jquery';
import breadcrumb from './frontend/breadcrumb';
import socialStickyNavInit from './frontend/social-sticky-nav';
import configureSearch from './frontend/search';
import nav from './frontend/nav';
import CACLoginPage from './frontend/cac-login-page';
import objectFitPolyfill from './frontend/object-fit-polyfill';
import viewportTriggers from './frontend/viewport-triggers';
import govBanner from './frontend/govBanner';
import '../scss/index.scss';
require('../images/af-logo-seal.png');

document.addEventListener(
  'DOMContentLoaded',
  () => {
    breadcrumb();
    configureSearch();
    nav();
    CACLoginPage();
    objectFitPolyfill();
    socialStickyNavInit();
    viewportTriggers();
    govBanner();
  },
  false
);
